import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppSharedUIModule } from 'app-shared-ui';
import { MatTooltipModule } from '@angular/material/tooltip';

import { TermsConditionComponent } from './term-condition/term-condition.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { ContactUsComponent } from './contact-us/contact-us.component';

@NgModule({
  declarations: [
    ContactUsComponent,
    PrivacyPolicyComponent,
    TermsConditionComponent
  ],
  imports: [
    AppSharedUIModule,
    MatTooltipModule,
    RouterModule.forChild([
      {
        path: 'termsofuse',
        component: TermsConditionComponent,
      },
      {
        path: 'privacypolicy',
        component: PrivacyPolicyComponent,
      },
      {
        path: 'contactus',
        component: ContactUsComponent,
      },
    ]),
  ],
})
export class AboutModule { }
